<template>
  <div class="popup-overlay pt-5">
      <div class="popup-content container">
        <div v-if="popupMsg" class="alert alert-info">{{popupMsg}}</div>
        <div class="row justify-content-center align-items-center" style="gap: 10px">
          <div class="col-12 col-md-6 justify-content-center align-items-center popup-container">

            <div class="d-flex flex-column text-left" style="color: #4B5568">
              <h3 v-if="popupStyle==='upgrade'"
                  style="color: #00668B; font-weight: bold;">Buy AI CREATOR plan</h3>
              <h3 v-if="popupStyle==='add-more'"
                  style="color: #00668B; font-weight: bold;">Add another Designer Plan for Your Team</h3>

              <div class="image-popup-container my-2">
                <div class="d-flex justify-content-between align-items-center">
                  <img class="popup-image" alt="Product Tour"
                       src="https://silkplm.com/wp-content/uploads/2024/12/Designer.png">
                  <div>
<!--                    <h2 class="text-success" style="font-weight: bold">Free for 7 days</h2>-->
<!--                    <p style="font-size: 20px; margin-bottom: 0 !important;">After That:</p>-->
                    <p><strong style="font-size: 24px">$14.99</strong> <br> per user/monthly</p>
                  </div>
                </div>
              </div>
              <ul style="list-style-type: none; padding-left: 0">
                <li style="margin-bottom: 7px">
                  <font-awesome-icon :icon="['fas', 'check']" style="color: #00668B; margin-right: 5px;"/>
                  AI Tools for designers
                </li>
                <li style="margin-bottom: 7px">
                  <font-awesome-icon :icon="['fas', 'check']" style="color: #00668B; margin-right: 5px"/>
                  Unlimited inspiration management
                </li>
                <li style="margin-bottom: 7px">
                  &nbsp;
                </li>
              </ul>
              <p v-if="canCancel7Days">
                <font-awesome-icon :icon="['fal', 'shield-check']" style="color: #52B79F; margin-right: 5px"/>
                24h money-back guarantee
              </p>
              <b-button @click="goToShopDesigner"
                        :disabled="!link"
                        style="background-color: #00668B; color: white; border: none; font-weight: bold; padding-top: 15px; padding-bottom: 15px">
                <span v-if='popupStyle==="upgrade"'>
                  Upgrade now!
                </span>
                <span v-if='popupStyle==="add-more"'>
                  Add more users now!
                </span>

              </b-button>
              <p>
                <font-awesome-icon :icon="['fal', 'shield-check']"
                                   style="color: #52B79F; margin-right: 5px; margin-top: 16px"/>
                Secure payments powered by <img style="width: 150px" alt="Paypal Stripe"
                                                src="https://silkplm.com/wp-content/uploads/2024/11/PayPal-and-stripe-2.png">
              </p>
              <b-button  v-if="popupCanClose"  class="link" @click="close">Not now</b-button>
              <b-link class="text-center" @click="signOut">Sign Out</b-link>
            </div>
          </div>

          <div class="col-12 col-md-6  justify-content-center align-items-center popup-container">
            <div class="d-flex flex-column text-left" style="color: #4B5568">
              <h3 v-if="popupStyle==='upgrade'"
                  style="color: #00668B; font-weight: bold;">Buy STARTUP plan</h3>
              <h3 v-if="popupStyle==='add-more'"
                  style="color: #00668B; font-weight: bold;">Add another Designer Plan for Your Team</h3>

              <div class="image-popup-container my-2">
                <div class="d-flex justify-content-between align-items-center">
                  <img class="popup-image" alt="Product Tour"
                       src="https://silkplm.com/wp-content/uploads/2024/12/Standard.png">
                  <div>
<!--                    <h2 class="text-success" style="font-weight: bold">Free for 7 days</h2>-->
<!--                    <p style="font-size: 20px; margin-bottom: 0 !important;">After That:</p>-->
                    <p><strong style="font-size: 24px">$59.99</strong> <br> per user/monthly</p>
                  </div>
                </div>
              </div>
              <ul style="list-style-type: none; padding-left: 0">
                <li style="margin-bottom: 7px">Everything in AI CREATOR plus:</li>
                <li style="margin-bottom: 7px">
                  <font-awesome-icon :icon="['fas', 'check']" style="color: #00668B; margin-right: 5px"/>
                  Product lifecycle management workflow
                </li>
                <li style="margin-bottom: 7px">
                  <font-awesome-icon :icon="['fas', 'check']" style="color: #00668B; margin-right: 5px"/>
                  Suppliers Portal
                </li>

              </ul>
              <p v-if="canCancel7Days">
                <font-awesome-icon :icon="['fal', 'shield-check']" style="color: #52B79F; margin-right: 5px"/>
                30-day money-back guarantee
              </p>
              <b-button @click="goToShopStandard"
                        :disabled="!link"
                        style="background-color: #00668B; color: white; border: none; font-weight: bold; padding-top: 15px; padding-bottom: 15px">
                <span v-if='popupStyle==="upgrade"'>
                  Upgrade now!
                </span>
                <span v-if='popupStyle==="add-more"'>
                  Add more users now!
                </span>

              </b-button>
              <p>
                <font-awesome-icon :icon="['fal', 'shield-check']"
                                   style="color: #52B79F; margin-right: 5px; margin-top: 16px"/>
                Secure payments powered by <img style="width: 150px" alt="Paypal Stripe"
                                                src="https://silkplm.com/wp-content/uploads/2024/11/PayPal-and-stripe-2.png">
              </p>
              <b-button v-if="popupCanClose" class="link" @click="close">Not now</b-button>
              <b-link class="text-center" @click="signOut">Sign Out</b-link>

            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import {buyPlan, loginToWp} from "@/components/subscriptions/Subs";
import {sendEvent} from "@/utils/GEvents";

export default {
  name: "Popup",
  async created() {
    this.link = await loginToWp();
  },

  methods: {
    signOut() {
      SessionManager.signOut()
    },
    close(){
      sendEvent("buy-plan-cancel");
      EventBus.$emit(Events.hideBuyPlanPopup);
    },
    goToShopStandard() {
      sendEvent("buy-standard-click");
      buyPlan(62, this.link);
    },
    goToShopDesigner() {
      sendEvent("buy-designer-click");
      buyPlan(97, this.link);
    }
  },
  props: {
    popupCanClose: {default: true},
    popupMsg: {default: ''},
    popupStyle: {default: 'upgrade'},
  },
  data: function(){
    return {
      canCancel7Days: true,
      link: null
    }
  }
};
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 9999;
  overflow: auto;
  padding-top: 30px;
}

.popup-image {
  width: 180px;
  height: auto;
}

.popup-container {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  max-width: 45%;
  text-align: center;
  min-width: 350px;
}

.popup-content {
  font-size: 16px;
}

</style>
